import React from 'react';

interface SelectionBoxProps {}

export const SelectionBox: React.FC<SelectionBoxProps> = () => {
  // For now, just return null as selection box requires more complex interaction
  // This would typically be implemented with pointer events and selection rectangle
  return null;
};
